import React from 'react'
import FirstView from '../../../../components/Business/FoodStadium/FirstView'
import SpecialCollaboration from '../../../../components/Business/FoodStadium/SpecialCollaboration'
import SuccessStory from '../../../../components/Business/FoodStadium/SuccessStory'
import Charm from '../../../../components/Business/FoodStadium/Charm'
import LargeCta from '../../../../components/Business/FoodStadium/LargeCta'
import Form from '../../../../components/Business/FoodStadium/Form'
import Footer from '../../../../components/Business/FoodStadium/Footer'

export default function FoodStadium() {
    return (
        <>
            <FirstView />
            <SpecialCollaboration />
            <SuccessStory />
            <Charm />
            <LargeCta />
            <Form />
            <Footer />
        </>
    )
}
